import React, { useEffect, useState } from 'react'
import Modal from '@mui/material/Modal'
import DialogContent from '@mui/material/DialogContent'
import CircularProgress from '@mui/material/CircularProgress'
import { useTranslation } from 'i18n'
import InstantWinWheel from './InstantWinWheel'
import analytics from 'global/AnalyticsData'
import { getUserType } from 'global/context/sub-contexts/userContext'
import { userTypeEnum } from 'services/user'
import './InstantWinModal.scss'

/**

    wheelConfig={
        title
        bodyCopy
        footerCopy
        prizeId - sent to InstantWinWheel
        shouldSpin - sent to InstantWinWheel
        noGraphic - BR-5696: no wheel, show imageUrl (optional) and the button instead
        loading - BR-5696: with noGraphic, a spinner while the result is on its way
        keepOpen - BR-5696: Escape, the backdrop and the close button do not close the modal
        imageUrl
    }


*/
const InstantWinModal = ({
  wheelConfig = {},
  wheelTheme,
  data,
  isModalOpen,
  handleCloseModal = () => {},
  button,
  handleAfterSpin = () => {},
  className=""
}) => {
  const { t } = useTranslation('shared')
  const isGuest = getUserType() === userTypeEnum.GUEST
  const [top, setTop] = useState((parseInt(window.embedPerceivedTop) + 20) + "px")
  const backdropStyle = {
    backdropFilter: 'blur(2px)',
    overflow: "scroll"
  }
  const style = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    // minHeight: 'var(--content-min-height)',
    position: 'fixed',
    top: top,
  }
  // BR-5696: the No Graphic modal is short, so center it on the screen. Inside an iframe the
  // screen is the parent page's, so it keeps the perceived-top offset there.
  if (wheelConfig.noGraphic && window.self === window.top) {
    style.top = '50%'
    style.transform = 'translateY(-50%)'
  }

  useEffect(() => {
    if (isModalOpen) {
      analytics.stepEvent('instant_win_modal_open', {}, { isGuest })
      setTop((parseInt(window.embedPerceivedTop) + 20) + "px")
    }
  }, [isModalOpen])

  // using visibility: hidden helps minimize layout shift
  let forfeitStyle = {}
  if (wheelConfig.hideForfeit) {
    forfeitStyle = { visibility: 'hidden' }
  }
  const modalCloseButtonhandler = () => {
    handleCloseModal()
    analytics.stepEvent('instant_win_forfeit_click', {}, { isGuest })
  }
  return (
    <>
      <Modal
        open={isModalOpen}
        onClose={wheelConfig.keepOpen ? undefined : handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={backdropStyle} 
            
      >
        <DialogContent style={style}>
            
          <div className={`instant-win-modal ${className}`}>
            <div className="instant-win-modal-content">
              {!wheelConfig.keepOpen && (
                <button
                  className={`modal-close`}
                  onClick={handleCloseModal}
                  aria-label="Next"
                ></button>
              )}
              {/* BR-5696: a No Graphic result shows its image above the copy, as in the Depend design */}
              {wheelConfig.noGraphic && !wheelConfig.loading && wheelConfig.imageUrl && (
                <img className="no-graphic-image" src={wheelConfig.imageUrl} alt="" />
              )}
              <h2 className="title">{wheelConfig.title}</h2>
              <h3 className="subtitle">{wheelConfig.bodyCopy}</h3>
              {wheelConfig.noGraphic && wheelConfig.loading ? (
                <div className="no-graphic no-graphic-loading" role="status">
                  <CircularProgress color="inherit" />
                  <p>{t('checkingReward')}</p>
                </div>
              ) : wheelConfig.noGraphic ? (
                <div className="no-graphic">
                  <div className="button-container">{button}</div>
                </div>
              ) : (
                <InstantWinWheel
                  data={data}
                  button={button}
                  wheelConfig={wheelConfig}
                  wheelTheme={wheelTheme}
                  handleAfterSpin={handleAfterSpin}
                />
              )}
              <div
                className="tandc"
                dangerouslySetInnerHTML={{ __html: wheelConfig.footerCopy }}
              />
              <div className="forfeit-container" style={forfeitStyle}>
                <span onClick={modalCloseButtonhandler} className="forfeit">
                  I'd like to forfeit
                </span>
              </div>
            </div>
          </div>
        </DialogContent>
      </Modal>
    </>
  )
}

export default InstantWinModal
